module.exports = __webpack_public_path__ + "img/Icon Fact Base.642f7e70.svg";